export const dbVersion: number = 1
export const configVersion: string = "1.0"
export const apiVersion: string = "15"
export const adminVersion: string = "1.0.28"
export const isProduction: boolean = false
export const dbName: string = "RavCreditDB"

export const dbAuthStore: string = "authStore"
export const dbUsersStore: string = "usersStore"
export const dbContractsStore: string = "contractsStore"
export const dbClientsStore: string = "clientsStore"
export const dbBusinessInfo: string = "businessInfo"
export const dbBusinessConfig: string = "businessConfig"
export const dbConektaClientsStore: string = "conektaClientsStore"
export const dbConektaReferencesStore: string = "conektaReferencesStore"
export const dbPassportReferencesStore: string = "passportReferencesStore"
export const dbDynamicReferencesStore: string = "dynamicReferencesStore"
export const dbNotificationsStore: string = "notificationsStore"
export const dbPaymentsStore: string = "paymentsStore"

export const dbIndexAuth: string = "iAuth"
export const dbIndexUsers: string = "iUsers"
export const dbIndexContracts: string = "iContracts"
export const dbIndexClients: string = "iClients"
export const dbIndexBusiness: string = "iBusiness"
export const dbIndexConektaClients: string = "iConecktaClients"
export const dbIndexConektaClientsRef: string = "iConecktaClientsRef"
export const dbIndexPassportClientsRef: string = "iPassportClientsRef"
export const dbIndexNotification: string = "iNotification"
export const dbIndexPayments: string = "iNotification"

export const keyPathId: string = "id"
export const keyPathReference: string = "reference"
export const keyPathCurp: string = "curp"

export const keyUserID: string = "rc_uid"
export const keyDBVersion: string = "rc_vn"

export const SubscriptionRefresh = "SubscriptionRefresh"

// export const apkUrl = "https://firebasestorage.googleapis.com/v0/b/ravcredit-2b079.appspot.com/o/mobile-app%2Fapp-release-313.apk?alt=media&token=b88c20f8-2ff9-4732-8949-0e3a62b5e741"
export const apkUr2 = "https://firebasestorage.googleapis.com/v0/b/ravcredit-2b079.appspot.com/o/mobile-app%2Fapp-release-313.apk?alt=media&token=f459a6e0-e694-4764-b322-99b1122d3b69"
export const apkUrl = "https://firebasestorage.googleapis.com/v0/b/ravcredit-2b079.appspot.com/o/mobile-app%2Fapp-release.apk?alt=media&token=ae05f332-a39a-46ad-8a64-312ae1487496"
export const mobileVersion = "3.1.4"

//
// {
//   "livemode": true,
//   "name": "PEDRO ALDANA MORENO",
//   "email": "periquin-super-zapato@outlook.com",
//   "phone": null,
//   "default_shipping_contact_id": null,
//   "default_fiscal_entity_id": null,
//   "referrer": null,
//   "id": "cus_2wVe97djPt8RePZuc",
//   "object": "customer",
//   "created_at": 1724363273,
//   "corporate": false,
//   "metadata": null,
//   "custom_reference": "",
//   "payment_sources": null,
//   "fiscal_entities": null,
//   "shipping_contacts": null
// },
